import type { LazyQueryHookOptions, QueryHookOptions } from "@apollo/client";
import { useLazyQuery, useQuery, gql } from "@apollo/client";

import type { GroupName } from "@shared/components/Typeahead/shared/TypeaheadGroupName";
import type { TypeaheadGroupType } from "@shared/types/graphqlGenerated";

const TYPEAHEAD_SEARCH_V2_QUERY = gql`
  query TypeaheadSearchV2_Shared_Query($query: String, $filters: SearchFilterObject) {
    viewer {
      typeaheadSearchV2(query: $query, filters: $filters) {
        entityType
        data {
          id
          name
          entityType
          brandName
          productSlug
        }
      }
    }
  }
`;

interface TypeaheadGroupTypeSplinter extends Pick<TypeaheadGroupType, "data"> {
  entityType: GroupName;
}

interface TypeaheadSearchDataV2 {
  viewer: {
    typeaheadSearchV2: TypeaheadGroupTypeSplinter[];
  };
}

type TypeaheadFilterListFieldFragment =
  | "INGREDIENTS"
  | "BRANDS"
  | "SUPPLEMENT_TYPES"
  | "CONDITIONS"
  | "PRODUCTS";

interface SearchFilterObject {
  list: TypeaheadFilterListFieldFragment[];
}

interface Variables {
  query: string;
  filters?: SearchFilterObject;
}

const useTypeaheadSearchV2Query = (options?: QueryHookOptions<TypeaheadSearchDataV2, Variables>) =>
  useQuery(TYPEAHEAD_SEARCH_V2_QUERY, options);

const useTypeaheadSearchV2LazyQuery = (
  options?: LazyQueryHookOptions<TypeaheadSearchDataV2, Variables>
) => useLazyQuery(TYPEAHEAD_SEARCH_V2_QUERY, options);

export type { TypeaheadSearchDataV2 };
export { useTypeaheadSearchV2Query, useTypeaheadSearchV2LazyQuery, TYPEAHEAD_SEARCH_V2_QUERY };
